import React from 'react';

const LocationIcon24 = ({ className }) => (
  <svg className={className} height="24" width="24">
    <path d="m12 11.5c-1.39 0-2.5-1.12-2.5-2.5 0-1.39 1.11-2.5 2.5-2.5 1.38 0 2.5 1.11 2.5 2.5 0 1.38-1.12 2.5-2.5 2.5m0-9.5c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.14-7-7-7z" />
  </svg>
);

export default LocationIcon24;
